import { get } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
  root: {
    color: get(theme, 'palette.primary.main'),
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      textDecorationLine: 'underline',
      color: get(theme, 'palette.primary.light'),
    },
  },
});

const TextButton = withStyles((props) => {
  const { classes } = props;

  return (
    <span className={classes.root} {...props}>
      {props.children}
    </span>
  );
}, styles);

export default TextButton;
